// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"style__materialize-textarea___V4PPs","modal-2463794813":"style__modal-2463794813___1apWh","container":"style__container___VXT3d","adaptContainer":"style__adaptContainer___1vSiq","emptyScreens":"style__emptyScreens___3Lxma","emptyImage":"style__emptyImage___2wou2","noDescFound":"style__noDescFound___3GnuN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CoachDashboardView/components/DivisionBasedStudent/style.scss
// module id = 1474
// module chunks = 0